import Vue from 'vue';
export default Vue.component('ed-p', { name: 'ed-p'});